export default __webpack_public_path__ + "media/images/burger-988b16997b30e8aa8ecef4d4e5b38e06.svg";